// extracted by mini-css-extract-plugin
export default {"root":"root--_CgbA","homePage":"homePage--sNGtd","brandImage":"brandImage--xo8kd","brandName":"brandName--Gwo_0"};